import styled from 'styled-components';
import Banner from '@chownow/cocina-react-banner';

const ErrorBanner = styled(Banner)`
  width: unset;
`;

export default ErrorBanner;
